import { APIClientRecord } from '../../../hooks/api-client-hooks';

export type DialogMode = 'create' | 'edit' | 'view';

export type APIClientFormState = {
  client_id?: string;
  name: string;
  description: string;
  enabled: boolean;
  role_ids: number[];
  token_ttl_seconds: number;
};

export const emptyApiClientForm: APIClientFormState = {
  client_id: undefined,
  name: '',
  description: '',
  enabled: true,
  role_ids: [],
  token_ttl_seconds: 3600,
};

export function normalizeText(value: any) {
  return String(value ?? '').trim();
}

export function dateLabel(value?: string | null) {
  if (!value) return '-';

  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleString();
  } catch {
    return String(value);
  }
}

export function formFromClient(client?: APIClientRecord | null): APIClientFormState {
  if (!client) return emptyApiClientForm;

  return {
    client_id: client.client_id,
    name: client.name || '',
    description: client.description || '',
    enabled: client.enabled !== false,
    role_ids: Array.isArray(client.role_ids) ? client.role_ids.map(Number) : [],
    token_ttl_seconds: Number(client.token_ttl_seconds || 3600),
  };
}

export function clientOwnerLabel(client: APIClientRecord) {
  return client.owner?.email || (client.owner_id ? `User ${client.owner_id}` : '-');
}

export function clientMatchesSearch(client: APIClientRecord, search: string) {
  const q = search.trim().toLowerCase();

  if (!q) return true;

  const haystack = [
    client.client_id,
    client.name,
    client.description,
    client.owner?.email,
    client.owner_id,
    client.updated_by,
    ...(client.role_ids || []),
  ]
    .filter((value) => value !== undefined && value !== null)
    .join(' ')
    .toLowerCase();

  return haystack.includes(q);
}

export function normalizeSelectStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map(String);
  }

  if (typeof value === 'string') {
    return value.split(',').map((item) => item.trim()).filter(Boolean);
  }

  return [];
}